import React from "react";

const style={
  backgroundImage: 'linear-gradient(to bottom right, #ccc, #ffb74d)',
  border: 'solid 3px black',
  padding: '0 5px 10px 5px',
  height: "250px"
}

export const AboutBox = props => {
  return (
    <div className="icon-block" style={style}>
      <h2 className="center brown-text" style={{marginTop:0}}>
        <i className={props.icon}></i>
      </h2>
      <h5 className="center">{props.title}</h5>

      <p className="light">
        {props.content}
      </p>
    </div>
  );
};
